import { Plugin } from 'vue';
import { install } from './plugin';
export { useGalleryBox } from './galleryBox';

export default {
  install,
} as Plugin;
